import type { Dict } from '../utils'

import { createContext } from '../utils'

const [PopoverProvider, usePopoverContext] = createContext<Dict>({ isOptional: true })

export { PopoverProvider, usePopoverContext }
